export default "__VITE_ASSET__DFmvKIlM__"